<template>
  <div id="formsjs"></div>
  <div ref="successEl" :class="[centerForm ? 'mx-auto' : '']">
    <div class="mb-8" v-show="showSuccess">
      <p
        class="bg-success border-success-dark text-16 border border-solid p-4 text-white">
        {{ successMessage.message }}
      </p>
    </div>
    <div v-if="showLegend" class="text-right">
      <span class="text-error-dark text-20 font-bold">*</span> = required
    </div>
    <div
      class="marketo-form"
      :class="[
        showLoading ? 'loading loading-show' : '',
        smallLabel ? 'marketo-form--label-small' : '',
        formLayoutClass,
        hideRequired ? 'marketo-form--hide-asterix' : '',
        fullWidthLastRow ? 'marketo-form--full-width-last-row' : '',
      ]">
      <form :id="formId"></form>
      <div class="loading-bkgd">
        <img :src="loading" class="loading-gif" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import postscribe from "postscribe";
import { computed, onMounted, ref } from "vue";
import loading from "../../../images/loading.svg";
import { useToast } from "vue-toastification";
import { useCustomValidator } from "../../compostables/useValidators";

/**
 * TODO
 * Work when more than one Marketo form on same page
 * Allow for redirect URL as prop
 * Scroll to success messasge
 */
export default {
  props: {
    fullWidthLastRow: {
      type: Boolean,
      default: false,
    },
    centerForm: {
      type: Boolean,
      default: false,
    },
    hideRequired: {
      type: Boolean,
      default: false,
    },
    formLayout: {
      type: String,
      default: "one column",
      vaildator(value) {
        return useCustomValidator(
          ["one column", "two column", "inline"],
          value
        );
      },
    },
    smallLabel: {
      type: Boolean,
      required: false,
      default: false,
    },
    mktoFormId: {
      type: Number,
      required: true,
    },
    redirectOnSuccess: {
      type: [Boolean, String],
      default: false,
    },
    showLegend: {
      type: Boolean,
      default: true,
    },
    successMessage: {
      type: Object,
      required: false,
      default: false,
    },
    successUrl: {
      type: String,
      required: false,
      default: null,
    },
  },

  setup(props, { slots }) {
    const formId = "mktoForm_" + props.mktoFormId;
    const showLoading = ref(true);
    const showSuccess = ref(false);
    const successEl = ref(null);
    const toast = useToast();

    const formLayoutClass = computed(() => {
      switch (props.formLayout) {
        case "two column":
          return "marketo-form--two-col";
          break;

        case "inline":
          return "marketo-form--inline";
          break;
      }
    });

    let submitBtnText = "";

    onMounted(() => {
      if (window.MktoForms2) {
        MktoForms2.loadForm(
          "//go.va529.info/",
          "736-VEE-917",
          props.mktoFormId,
          function (mktoForm) {
            mktoForm.onSuccess(function () {
              if (props.redirectOnSuccess === false) {
                if (props.successMessage.type !== "popup") {
                  showSuccess.value = true;

                  const top = successEl.value.offsetTop;
                  window.scrollTo(0, top - 100);
                } else {
                  toast.success(props.successMessage.message);
                }

                const formElement = mktoForm.getFormElem()[0];
                const btn = formElement.querySelector("button[type='submit']");

                btn.removeAttribute("disabled");
                btn.innerHTML = submitBtnText;

                formElement.reset();
              }

              return false;
            });
          }
        );

        MktoForms2.whenReady(function (mktoForm) {
          const formEl = mktoForm.getFormElem()[0];
          const formRows = formEl.getElementsByClassName("mktoFormRow");
          let lastRow,
            lastRowChild,
            i = 1;

          // Find last row of form inputs
          do {
            lastRow = formRows[formRows.length - i];
            lastRowChild = lastRow.firstChild;
            i++;
          } while (lastRowChild.tagName != "DIV" && lastRowChild.classList.contains("mktoFieldDescriptor"));

          // Put class on last row for styling
          lastRow.classList.add("last-row");

          // Find row with hidden elements
          const hiddenRowEl = formEl.querySelectorAll(
            '.mktoFormRow [type="hidden"]'
          );

          // Add class to row with hidden elements
          if (hiddenRowEl.length) {
            hiddenRowEl[0].closest(".mktoFormRow").classList.add("hidden-row");
          }

          // Hide divs with no class and captcha badge
          // formEl.querySelector("div:not([class])").classList.add("hidden-row");
          if (formEl.querySelector("#captcha")) {
            formEl.querySelector("#captcha").classList.add("hidden-row");
          }

          // Hide script tag div
          if (formEl.querySelector("div > script")) {
            formEl
              .querySelector("div > script")
              .parentElement.classList.add("hidden-row");
          }

          // Save Submit button text for when reseting form
          submitBtnText = formEl.querySelector(
            "button[type='submit']"
          ).innerHTML;

          // Hide loading gif
          showLoading.value = false;
        });
      }
    });

    return {
      formId,
      formLayoutClass,
      showLoading,
      showSuccess,
      successEl,
      loading,
    };
  },
};
</script>
